<div class="loader-overlay" [ngClass]="{'loader-overlay-sticky': state.preloaderName === 'root'}" [@animateOpacity]="state.type" *ngIf="state.type === 'LinearSpinner'">
    <div>
        <mat-progress-bar class="linear-mat-spinner" mode="indeterminate"></mat-progress-bar>
    </div>
</div>
<div class="preloader-container" [@animateOpacity]="state.type" *ngIf="state.type === 'RoundSpinner'">
    <div class="spinner-holder">
        <div layout="row" class="mat-spinner">
            <mat-spinner></mat-spinner>
            <br>
            <mx-button [buttonModel]="cancelButton"></mx-button>
        </div>
    </div>
</div>
